import React from 'react';
import { CheckCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import type { ChatProposal } from '../../../api/agentChat/interface';
import styles from '../Chat.module.scss';
import { EscalationEffectBody } from '../ProposalCard';

interface Props {
  messageId: string;
  proposals: ChatProposal[];
  proposalSubmitting: Record<string, boolean>;
  onApprove: (messageId: string, proposalId: string) => void;
  onReject: (messageId: string, proposalId: string) => void;
}

const PendingProposalsPanel: React.FC<Props> = ({
  messageId,
  proposals,
  proposalSubmitting,
  onApprove,
  onReject,
}) => (
  <div className={styles.pendingWrapper}>
    {proposals.map((p) => (
      <div key={p.proposal_id} className={styles.pendingCard}>
        {p.expected_effects ? (
          <EscalationEffectBody raw={p.expected_effects} />
        ) : (
          <p className={styles.pendingQuestion}>{p.directive}</p>
        )}
        <div className={styles.pendingActions}>
          <Button
            type="primary"
            icon={<CheckCircleOutlined />}
            className={styles.pendingApproveBtn}
            onClick={() => onApprove(messageId, p.proposal_id)}
            disabled={!!proposalSubmitting[p.proposal_id]}
          >
            Approve
          </Button>
          <Button
            className={styles.pendingRejectBtn}
            onClick={() => onReject(messageId, p.proposal_id)}
            disabled={!!proposalSubmitting[p.proposal_id]}
          >
            Reject
          </Button>
        </div>
      </div>
    ))}
  </div>
);

export default PendingProposalsPanel;
